export default __webpack_public_path__ + "static/9-e311f6539ab6517a38a94130c13420d9.jpg";